import { z } from "zod";

const GeoExtentFieldsSchema = z.object({
	minLatitude: z.coerce.number().optional(),
	maxLatitude: z.coerce.number().optional(),
	minLongitude: z.coerce.number().optional(),
	maxLongitude: z.coerce.number().optional(),
	MinLatitude: z.coerce.number().optional(),
	MaxLatitude: z.coerce.number().optional(),
	MinLongitude: z.coerce.number().optional(),
	MaxLongitude: z.coerce.number().optional(),
});

/** Server max-extent response (swagger `Extent`). Accepts camelCase or PascalCase. */
export const GeoExtentSchema = GeoExtentFieldsSchema.transform((data) => ({
	minLatitude: data.minLatitude ?? data.MinLatitude,
	maxLatitude: data.maxLatitude ?? data.MaxLatitude,
	minLongitude: data.minLongitude ?? data.MinLongitude,
	maxLongitude: data.maxLongitude ?? data.MaxLongitude,
})).pipe(
	z.object({
		minLatitude: z.number(),
		maxLatitude: z.number(),
		minLongitude: z.number(),
		maxLongitude: z.number(),
	}),
);

export type GeoExtent = z.infer<typeof GeoExtentSchema>;

export interface MaxExtentRequestOptions {
	/** Sent as the `organization-id` header (not a query param). */
	organizationId?: string;
	/** Query param when exactly one sub-organization filter is active. */
	subOrganizationId?: string;
}
